import React from 'react'
import { connect } from 'react-redux'
import EcommerceProductActions from '../../Redux/EcommerceProductRedux'
import SizeActions from '../../Redux/SizeRedux'
import ColourActions from '../../Redux/ColourRedux'
import WarehouseActions from '../../Redux/WarehouseRedux'
import Select from 'react-select'

class CreateEcommerceProduct extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      id: props.detail.id,
      name: props.detail.name,
      selectedSize: '',
      selectedColour: '',
      selectedWarehouse: '',
      ecommerceProduct: {
        inventory_id: '',
        sku_v: '',
        varian_size_id: '',
        varian_colour_id: '',
        quantity: '',
        supplier: '',
        price: 0,
        buy_price: 0,
        warehouse_id: '',
        vm_product_id: ''
      }
    }
  }

  componentDidMount = () => {
    this.props.getColour()
    this.props.getSize()
    this.props.getWarehouse()
    const { colour, size, warehouse } = this.props
    let colourPicker = []
    let sizePicker = []
    let warehousePicker = []

    colour.dataAll.map((item, i) => {
      colourPicker[i] = {
        value: item.id,
        label: item.name
      }
      return colourPicker
    })
    this.colourPicker = colourPicker

    size.dataAll.map((item, i) => {
      sizePicker[i] = {
        value: item.id,
        label: item.name
      }
      return sizePicker
    })
    this.sizePicker = sizePicker

    warehouse.data.map((item, i) => {
      warehousePicker[i] = {
        value: item.id,
        label: item.name
      }
      return warehousePicker
    })
    this.warehousePicker = warehousePicker
  }

  _inputChange = (event, field) => {
    let ecommerceProduct = { ...this.state.ecommerceProduct }
    if (field === 'varian_size_id') {
      ecommerceProduct.varian_size_id = event.value
      this.setState({ selectedSize: event, ecommerceProduct })
    } else if (field === 'varian_colour_id') {
      ecommerceProduct.varian_colour_id = event.value
      this.setState({ selectedColour: event, ecommerceProduct })
    } else if (field === 'warehouse_id') {
      ecommerceProduct.warehouse_id = event.value
      this.setState({ selectedWarehouse: event, ecommerceProduct })
    } else {
      let value = event.target.value
      ecommerceProduct[field] = value
      this.setState({ ecommerceProduct })
    }
  }

  _submit = (event) => {
    event.preventDefault()
    let form = { ...this.state.ecommerceProduct }
    const data = {
      id: this.state.id,
      form
    }
    this.props.createEcommerceProduct(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    return (
      <div className='section' style={{ width: '60vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>Add Product Variant</h4>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group row'>
            <div className='col-12'>
              <h3 className='control-label text-center'>{this.state.name}</h3>
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>SKU Varian</label>
            </div>
            <div className='col-9'>
              <input
                required
                type='text'
                className='form-control'
                value={this.state.ecommerceProduct.sku_v}
                onChange={(event) => this._inputChange(event, 'sku_v')}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Type</label>
            </div>
            <div className='col-9'>
              <Select
                options={this.colourPicker}
                name='colour-picker'
                required
                placeholder='Pick available type'
                value={this.state.selectedColour}
                onChange={(selectedColour) => this._inputChange(selectedColour, 'varian_colour_id')}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Subtype</label>
            </div>
            <div className='col-9'>
              <Select
                options={this.sizePicker}
                name='size-picker'
                required
                placeholder='Pick available subtype'
                value={this.state.selectedSize}
                onChange={(selectedSize) => this._inputChange(selectedSize, 'varian_size_id')}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Vending Machine ID</label>
            </div>
            <div className='col-9'>
              <input
                type='number'
                className='form-control'
                value={this.state.ecommerceProduct.vm_product_id}
                onChange={(event) => this._inputChange(event, 'vm_product_id')}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Price</label>
            </div>
            <div className='col-9'>
              <input
                required
                type='number'
                min='0'
                className='form-control'
                value={this.state.ecommerceProduct.price}
                onChange={(event) => this._inputChange(event, 'price')}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Buy Price</label>
            </div>
            <div className='col-9'>
              <input
                type='number'
                min='0'
                className='form-control'
                value={this.state.ecommerceProduct.buy_price}
                onChange={(event) => this._inputChange(event, 'buy_price')}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Warehouse</label>
            </div>
            <div className='col-9'>
              <Select
                options={this.warehousePicker}
                name='warehouse-picker'
                required
                placeholder='Pick available warehouse'
                value={this.state.selectedWarehouse}
                onChange={(selectedWarehouse) => this._inputChange(selectedWarehouse, 'warehouse_id')}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Quantity</label>
            </div>
            <div className='col-9'>
              <input
                required
                type='number'
                min='1'
                className='form-control'
                value={this.state.ecommerceProduct.quantity}
                onChange={(event) => this._inputChange(event, 'quantity')}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Cancel</button>
              <button type='submit' className='btn btn-primary'>Save</button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  size: state.size,
  colour: state.colour,
  warehouse: state.warehouse
})

const dispatchToProps = (dispatch) => ({
  getSize: () => dispatch(SizeActions.getAllSizeRequest()),
  getColour: () => dispatch(ColourActions.getAllColourRequest()),
  getWarehouse: () => dispatch(WarehouseActions.getWarehouseRequest()),
  createEcommerceProduct: (form) => dispatch(EcommerceProductActions.createEcommerceProductRequest(form))
})

export default connect(stateToProps, dispatchToProps)(CreateEcommerceProduct)



// WEBPACK FOOTER //
// ./src/Containers/Ecommerce/CreateEcommerceProduct.js